module.exports = __webpack_public_path__ + "static/img/4areaA_6.4149f5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/4areaA_6.png
// module id = 809
// module chunks = 1